import { TZDate } from '@date-fns/tz';
import { format, parseISO } from 'date-fns';

export const convertedTime = (
  time: string,
  isTimeInBrowserSettings: boolean,
  appConfig: typeof CSS_CONFIG,
): string => {
  const timeformat = appConfig.formats.dateAndTime.time;
  // Back-end is sometime sending time in format `2020-10-26T11:30:00Z` instead
  // of `2020-10-26T11:30:00+00:00` when UTC. Here converting the time to this.
  const corTime = time.slice(-1) === 'Z' ? time.replace(/.$/, '+00:00') : time;

  const [availableDate, offset] =
    corTime.indexOf('+') > 0 ? corTime.split('+') : corTime.split(/-(?!.*-)/);
  const formatedAvailableDate = parseISO(availableDate);
  const [hour, minutes] = offset.split(':');

  if (minutes.indexOf('Z') > 0) {
    const minute = minutes.slice(0, -1);

    if (time.indexOf('+') > 0) {
      formatedAvailableDate.setHours(
        formatedAvailableDate.getHours() + parseInt(hour, 10),
      );
      formatedAvailableDate.setMinutes(
        formatedAvailableDate.getMinutes() + parseInt(minute, 10),
      );
    } else {
      formatedAvailableDate.setHours(
        formatedAvailableDate.getHours() - parseInt(hour, 10),
      );
      formatedAvailableDate.setMinutes(
        formatedAvailableDate.getMinutes() - parseInt(minute, 10),
      );
    }
  }

  if (isTimeInBrowserSettings) {
    return format(parseISO(time), timeformat);
  }
  return format(formatedAvailableDate, timeformat);
};

export const dateToCalendar = (date: string, IANATimeZone: string): Date => {
  return new TZDate(parseISO(date), IANATimeZone);
};

export const getCurrentDateAndTime = () => {
  return format(new Date(), 'yyyy-MM-dd HH:mm');
};
